import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import ContactSection from "@/components/feature/ContactSection";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-cream-50 font-sans text-ink-950">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full pt-28 pb-10 md:pt-36 md:pb-14 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20geometric%20shapes%20suggesting%20connection%20and%20communication%2C%20soft%20amber%20and%20cream%20tones%2C%20modern%20minimalist%20corporate%20aesthetic%2C%20clean%20sophisticated%20composition%2C%20editorial%20design%20quality%2C%20high%20detail%2C%20harmonious%20peaceful%20atmosphere%2C%20no%20text&width=1600&height=900&seq=contact-hero-01&orientation=landscape"
              alt=""
              aria-hidden
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-ink-950/60 via-ink-950/40 to-ink-950/20"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 mb-5">
                <span className="w-2 h-2 rounded-full bg-amber-400"></span>
                <span className="text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-amber-200">
                  Contact Us
                </span>
              </div>
              <h1 className="font-display font-bold text-cream-50 leading-[1.08] tracking-tight text-4xl md:text-5xl lg:text-6xl">
                Let&rsquo;s build something great together
              </h1>
              <p className="mt-5 text-sm md:text-base text-cream-50/80 leading-relaxed max-w-lg">
                Have a project in mind or a question? Reach out — we typically respond within 24 hours.
              </p>
            </div>
          </div>
        </section>

        <ContactSection showHeading={false} />
      </main>
      <Footer />
    </div>
  );
}